import { createContext, useContext } from "react";

import { OnboardingStepperHandler } from "./onboarding.types";

export const OnboardingStepperContext = createContext({} as OnboardingStepperHandler);

export const useOnboardingContext = () => useContext(OnboardingStepperContext);
